export default __webpack_public_path__ + "static/media/icon-black-no-margin.235bb5c9.png";